import React from "react";
import { Edit, Trash2, FileText, Share2 } from "lucide-react";

const TemplateCard = ({ template, onEdit, onDelete, onView }) => {
  const { canModify = false, isShared = false } = template;

  return (
    <div
      onClick={() => onView(template)}
      className="flex flex-col bg-card rounded-xl shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] outline outline-1 outline-border hover:shadow-md transition-all relative overflow-hidden min-h-[200px] cursor-pointer"
    >
      <div className="self-stretch p-5 flex flex-col justify-start items-start gap-4">
        <div className="self-stretch inline-flex justify-start items-center gap-3 min-w-0">
          <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border border-border bg-muted">
            <FileText className="w-5 h-5 text-foreground" />
          </div>
          <h2
            className="flex-1 min-w-0 text-foreground text-base font-semibold font-['Inter'] leading-6 truncate"
            title={template.name}
          >
            {template.name}
          </h2>
          {isShared && !canModify && (
            <span
              className="flex-shrink-0 flex items-center justify-center"
              title="Shared with you"
            >
              <Share2 className="w-4 h-4 text-muted-foreground" aria-hidden />
            </span>
          )}
        </div>
        <p
          className="self-stretch text-muted-foreground text-sm font-normal font-['Inter'] leading-5 line-clamp-3"
          title={template.body}
        >
          {template.body}
        </p>
      </div>

      {canModify && (
        <div className="mt-auto self-stretch flex flex-col justify-start items-center">
          <div className="self-stretch h-px bg-border" />
          <div className="self-stretch px-5 py-4 inline-flex justify-between items-center gap-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(template);
              }}
              className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2 text-sm font-semibold"
              title="Edit Template"
            >
              <Edit className="w-4 h-4" />
              Edit
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(template);
              }}
              className="text-muted-foreground hover:text-red-600 transition-colors"
              title="Delete Template"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplateCard;
